import React from 'react';
import { useSelector } from 'react-redux';
import { designSystem } from '@yola/ws-ui';
import segment from 'src/js/modules/analytics/segment';
import mainMenu from 'src/js/modules/main-menu';
import getVisibilityStatus from '../selectors/get-visibility-status';

const { EditorHeader } = designSystem;

const {
  trackers: { trackEvent },
  constants: { events },
} = segment;

function NavToggle() {
  const isOpen = useSelector(getVisibilityStatus);

  const onClick = (event) => {
    event.stopPropagation();

    if (isOpen) {
      mainMenu.operations.hide();
    } else {
      mainMenu.operations.show();

      trackEvent(events.APP_MAIN_MENU_DISPLAYED);
    }
  };

  return (
    <div className="ws-nav__toggle">
      <EditorHeader.Menu
        glyph={isOpen ? 'close' : 'floating-menu'}
        onClick={onClick}
        transparent={isOpen}
      />
    </div>
  );
}

export default NavToggle;
